import React from "react";

const TopNav = () => {
  return (
    <nav className="hidden md:block w-full bg-primaryBgColor text-white overflow-hidden fixed top-0 left-0 z-50">
      <div className="flex items-center justify-center h-10">
        <div className="whitespace-nowrap text-xs sm:text-sm font-normal tracking-wider">
          Smart Capital for Fast-Growing Businesses
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
